export enum DobReasonType {
  YES = "1",
  DOB_MISSING = "2",
  DOB_INCORRECT = "3",
}
